import { render, staticRenderFns } from "./QuayDockEdit.vue?vue&type=template&id=01ca6d68&scoped=true&"
import script from "./QuayDockEdit.vue?vue&type=script&lang=js&"
export * from "./QuayDockEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca6d68",
  null
  
)

export default component.exports